import { defineStore } from "pinia";

export const useTokenStore = defineStore({
  id: "tokenStore",
  state: () => ({
    token:
      "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbl90eXBlIjoiQVBJIEtFWSIsImV4cCI6MjI2MzIxMjEzMCwiaWF0IjoxNjU4NDEyMTMwLCJqdGkiOiJlNGQxNDYwNTU5MGY0YzhmODU2ZWVjM2U1MWQwM2M0ZCIsIm9yZ2FuaXphdGlvbl9pZCI6IjAxODYyY2JhLWYwMTItNGUyNi1hZTA1LTgzZWEzOTc4MTU3ZSJ9.UtdcP9xW_-PbXq-eeQqLQ_nHEt9R6OOLOT57DLrMPI0",
  }),
});
